import { settingsExtractedMessages } from "@/i18n/catalogs/en/settings.extracted";
import { readingExtractedMessages } from "@/i18n/catalogs/en/reading.extracted";
import { libraryExtractedMessages } from "@/i18n/catalogs/en/library.extracted";
import { insightsExtractedMessages } from "@/i18n/catalogs/en/insights.extracted";
import { communityExtractedMessages } from "@/i18n/catalogs/en/community.extracted";
import { commonExtractedMessages } from "@/i18n/catalogs/en/common.extracted";
import { authExtractedMessages } from "@/i18n/catalogs/en/auth.extracted";
import { commonMessages } from "@/i18n/catalogs/en/common";
import { authMessages } from "@/i18n/catalogs/en/auth";
import { settingsMessages } from "@/i18n/catalogs/en/settings";
import { errorMessages } from "@/i18n/catalogs/en/errors";
import { notificationMessages } from "@/i18n/catalogs/en/notifications";

export const englishMessages = {
  ...settingsExtractedMessages,
  ...readingExtractedMessages,
  ...libraryExtractedMessages,
  ...insightsExtractedMessages,
  ...communityExtractedMessages,
  ...commonExtractedMessages,
  ...authExtractedMessages,
  ...authMessages,
  ...commonMessages,
  ...settingsMessages,
  ...errorMessages,
  ...notificationMessages,
} as const;

export type MessageId = keyof typeof englishMessages;
